module.exports = __webpack_public_path__ + "Tinebase/js/ace-plain_text-FAT.js";